import { FC } from "react";

import { IconCheckmark } from "@/components/_icons/IconCheckmark";

import DataSourceViewOptional from "./data-source-view-optional";

export interface DataSourceSelectDropdownItemProps {
  dataSource: string;
  isSelected?: boolean;
}

export const DataSourceSelectDropdownItem: FC<DataSourceSelectDropdownItemProps> = ({ dataSource, isSelected }) => {
  return (
    <div className="m-1 flex w-full cursor-pointer flex-row items-center gap-2 p-1 text-xs">
      <DataSourceViewOptional dataSourceTitle={dataSource} />
      <div className="mr-2 w-3">
        {isSelected && (
          <IconCheckmark className="mr-2 h-3 w-3 shrink-0 self-end justify-self-center text-foreground/60" />
        )}
      </div>
    </div>
  );
};
